import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActiveErrorResponse } from '@vi-iot/client/index';

import { SearchResultActiveErrorsPopupComponent } from './search-result-active-errors-popup/search-result-active-errors-popup.component';

@Component({
  selector: 'app-search-result-active-errors',
  templateUrl: './search-result-active-errors.component.html',
  styleUrls: ['./search-result-active-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultActiveErrorsComponent {
  @Input() errors: ActiveErrorResponse[];

  constructor(public dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(SearchResultActiveErrorsPopupComponent, {
      width: '768px',
      data: {
        errors: this.errors,
      },
    });
  }
}
